import RoutesMain from "src/routes";
import { hotjar } from "react-hotjar";
import Layout from "./Layout";

function App() {
  const env = process.env.REACT_APP_ENV;
  if (env == "prod") hotjar.initialize(3293390, 6);
  if (env == "dev") hotjar.initialize(3293397, 6);
  if (env != "local") hotjar.event("button-click");

  return (
    <Layout>
      <RoutesMain />
    </Layout>
  );
}
//style seet

export default App;
